<i class="fal fa-clock btn-xs btn-icon simple-icon" style="color: #94a3b8;"
    [popover]="timesDetails"
    container="body"
    containerClass="confirmation-popover"
    placement="right"
    triggers="mouseenter mouseleave"
    containerClass="many-to-one-popover"
    #pop="bs-popover"></i>
<ng-template #timesDetails>
    <table class="m-0 table-small">
        <thead>
            <tr>
                <th>{{ 'Last modified' | translate }}</th>
                <th>{{ 'Created' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>
                    <small>{{ item.lastChangedBy }}<source-badge [source]="item.lastChangedSource"></source-badge></small>
                    <br>
                    <small><b>{{ item.lastChangedWhen | date: 'dd-MM-yyyy' }}</b></small>
                </td>
                <td>
                    <small>{{ item.createdBy }}<source-badge [source]="item.createdSource"></source-badge></small>
                    <br>
                    <small><b>{{ item.createdWhen | date: 'dd-MM-yyyy' }}</b></small>
                </td>
            </tr>
        </tbody>
    </table>
</ng-template>
